import React, { useState, useEffect, useRef } from "react";
import ReactEcharts from "echarts-for-react";
import axios from "axios";
import API from "@/api";
import GbiArrow from "../../../../../assets/images/gbiArrow.svg";
import { Modal } from "antd";
import DetailTable from "../detailTable";

function PieData(props) {
  const {
    data: initialData = {},
    question_id,
    drillable,
    drillActions,
    changSpining,
  } = props;
  const [historyStack, setHistoryStack] = useState([
    {
      title: drillable === "true" || drillable === true ? "" : "",
      rawData: initialData,
    },
  ]);
  useEffect(() => {
    setHistoryStack([
      {
        title: drillable === "true" || drillable === true ? "" : "",
        rawData: initialData,
      },
    ]);
  }, [initialData]);
  // 当前显示的数据永远是栈顶的数据
  const currentStackItem = historyStack[historyStack.length - 1];
  const currentData = currentStackItem.rawData;

  // 2. 新增：使用 useRef 记录上一次点击的维度值
  const lastClickedDimRef = useRef(null);

  const { metric_fields, data: dData, dim_field } = currentData;

  const [newDrillable, setNewDrillable] = useState(drillable);
  const [dimField, setDimField] = useState(currentData?.dim_field?.field);
  const [newActionId, setNewActionId] = useState(
    drillActions?.[0]?.action_id || "",
  );
  const [detailable, setDetailable] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const dimFieldRef = useRef(dimField);
  const drillableRef = useRef(newDrillable);
  const actionIdRef = useRef(newActionId);

  let pieSeriesData = [];
  const nameCount = {};
  (dData || []).forEach((row) => {
    // 获取维度名称 (例如 "2025-2026")
    let dimName = row[0];

    // 获取数值 (例如 809)
    // 注意：这里假设数值在索引 1 的位置。
    // 如果您的 metric_fields 有多个，这里需要更复杂的逻辑来对应列。
    let value = row[1];

    // --- 处理重复名称逻辑 ---
    // 如果名称已存在，添加后缀区分，否则饼图无法区分扇区
    if (nameCount[dimName] !== undefined) {
      nameCount[dimName]++;
      dimName = `${dimName} (组${nameCount[dimName]})`;
    } else {
      nameCount[dimName] = 1;
    }

    // 推入饼图所需格式
    pieSeriesData.push({
      name: dimName,
      value: value,
    });
  });

  useEffect(() => {
    dimFieldRef.current = dimField;
  }, [dimField]);

  useEffect(() => {
    drillableRef.current = newDrillable;
  }, [newDrillable]);

  useEffect(() => {
    actionIdRef.current = newActionId;
  }, [newActionId]);

  const getOptions = () => {
    return {
      title: {
        text: metric_fields?.[0]?.name || "",
        left: "30%",
        textStyle: {
          color: "#aaa", // 字体颜色
          fontSize: 13, // 字体大小
          fontWeight: "bold", // 字体加粗
        },
      },
      grid: {
        top: "5%", // 默认通常是 '10%' 或更多，调小这个值
        bottom: "5%", // 也可以顺便调整底部
        left: "5%",
        right: "5%",
        containLabel: true, // 关键：确保标签不会被裁剪
      },
      tooltip: {
        trigger: "item",
        // formatter: "{b}: {c}人 ({d}%)", // 显示：名称: 数值(百分比)
        formatter: function (params) {
          // console.log(params);
          // params 是一个数组，包含当前 axis 上所有 series 的数据
          let result =
            params.name +
            "<br/>" +
            `${params.seriesName}: ${params.value.toLocaleString()}${
              metric_fields?.[0]?.unit || ""
            }<br/>`; // 显示日期或类目
          return result;
        },
      },
      series: [
        {
          name: metric_fields ? metric_fields[0].name : "", // 系列名称
          type: "pie",
          radius: "50%", // 饼图半径
          center: ["35%", "50%"],
          data: pieSeriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],

      legend: {
        type: "scroll",
        orient: "vertical", // 垂直排列
        right: 5, // 距离右侧 10px
        top: 30, // 垂直居中
        itemGap: 20, // 图例项之间的间距
        textStyle: {
          fontSize: 12,
        },
        itemWidth: 10,
        itemHeight: 10,

        formatter: function (name) {
          var data = pieSeriesData; // 假设这是你的数据源
          var total = 0;
          var currentValue = 0;

          // 1. 计算总和
          for (var i = 0; i < data.length; i++) {
            total += data[i].value;
          }

          // 2. 获取当前项数值并计算占比
          for (var i = 0; i < data.length; i++) {
            console.log(data[i].name, name, "这是啥");
            if (data[i].name + "" === name) {
              currentValue = data[i].value;
              break;
            }
          }

          // 3. 核心公式：(当前值 / 总和) * 100
          // 注意：要防止 total 为 0 的情况
          var percent =
            total === 0 ? 0 : ((currentValue / total) * 100).toFixed(2);

          // 4. 返回格式：名字 : (数值) 百分比
          // 例如：材料科学与工程学院 : (1974.00) 19.77%
          return (
            name +
            " : (" +
            (Number.isInteger(currentValue)
              ? currentValue.toLocaleString()
              : (currentValue.toFixed(2)).toLocaleString()) +
            (metric_fields?.[0]?.unit || "") +
            ") " +
            percent +
            "%"
          );
        },
      },
    };
  };

  const handleChartClick = (params) => {
    // console.log(params, dimField);
    //确保点击的是数据点
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      const clickedDimName = params.name;

      // 3. 核心修复：防重判断
      // 如果当前点击的维度和上一次完全一样，直接 return，拦截重复请求
      if (lastClickedDimRef.current === clickedDimName) {
        return;
      }
      if (newDrillable === true || newDrillable === "true") {
        changSpining(true);
      } else {
        changSpining(false);
      }
      // 更新 ref 为当前点击的维度
      lastClickedDimRef.current = clickedDimName;
      if (newDrillable === true || newDrillable === "true") {
        axios
          .post(API.getFilterAndNextData, {
            question_id,
            dim_field: dimFieldRef.current,
            dim_value: clickedDimName || "",
            // drill_path_id: actionIdRef?.current || "",
          })
          .then((res) => {
            const newData = res?.data?.chart_data || {};
            // 将新层级压入栈中
            setNewDrillable(res?.data?.drillable);
            setDetailable(res?.data?.detailable);
            setHistoryStack((prev) => {
              // 始终保留第一项（全部/根节点）的数据引用
              const firstItem = prev[0] || {
                title: "全部",
                rawData: initialData,
              };

              // 返回：[根节点, ...中间所有层级, 新节点]
              return [
                { title: "全部", rawData: firstItem.rawData },
                ...prev.slice(1),
                { title: clickedDimName, rawData: newData },
              ];
            });

            setDimField(res?.data?.chart_data?.dim_field?.field);
            setNewActionId(res?.data?.drill_actions?.[0]?.action_id || "");
            changSpining(false);
          })
          .catch((err) => {
            console.error("下钻请求失败", err);
          });
      } else {
        console.log("不能下钻啦");
      }
    }
  };

  // 3. 处理面包屑点击（返回）
  const handleBreadcrumbClick = (index) => {
    // 如果点击的是当前层级，不做操作
    if (index === historyStack.length - 1) return;

    // 截取数组，保留到点击的那一层
    if (index === 0) {
      setHistoryStack((prev) => {
        console.log(prev.slice(0, index + 1));
        const item = prev.slice(0, index + 1)?.[0];
        return [{ ...item, title: "" }];
      });
    } else {
      setHistoryStack((prev) => prev.slice(0, index + 1));
    }
    lastClickedDimRef.current = "";
    setNewDrillable(true);
    setDimField(historyStack[index]?.rawData?.dim_field?.field);
  };

  const handleDetail = (params) => {
    if (params.componentType === "series" && params.dataIndex !== undefined) {
      if (detailable) {
        setDetailOpen(true);
        lastClickedDimRef.current = params?.name;
      }
    }
  };

  return (
    <>
      <ReactEcharts
        key={JSON.stringify(currentData)}
        style={{
          minHeight: "225px",
          maxHeight: "300px",
          width: "100%",
        }}
        option={getOptions()}
        onEvents={
          newDrillable === true || newDrillable === "true"
            ? {
                click: handleChartClick,
              }
            : {
                click: handleDetail,
              }
        }
        notMerge={true} // 推荐开启，确保每次 setOption 替换旧配置而不是合并
        lazyUpdate={true}
      />

      {/* 4. 渲染面包屑导航 */}
      <div
        className="historyStack"
        style={{
          padding: drillable === "true" || drillable === true ? "" : "unset",
        }}
      >
        <div>
          {historyStack.map((item, index) => (
            <span key={index}>
              {/* 如果不是最后一项，或者虽然是最后一项但还有下级（理论上最后一项是当前），都可以点击 */}
              <span
                style={
                  index === historyStack.length - 1
                    ? {}
                    : {
                        cursor: "pointer",
                        color: "#1C69FC",
                      }
                } // 当前层级不加手型样式
                onClick={() => handleBreadcrumbClick(index)}
              >
                {item.title}
              </span>
              {/* 如果不是最后一项，显示分隔符 */}
              {index < historyStack.length - 1 && (
                <span
                  style={{
                    padding: "0 10px ",
                  }}
                >
                  <img
                    style={{
                      width: "8px",
                    }}
                    src={GbiArrow}
                    alt=" "
                  />
                </span>
              )}
            </span>
          ))}
        </div>
        <div
          style={{
            color: "#aaa",
          }}
        >
          {drillable === "true" || drillable === true
            ? "点击维度可下钻"
            : detailable
            ? "点击维度可下钻"
            : undefined}
        </div>
      </div>

      <Modal
        title="明细表"
        destroyOnHidden
        open={detailOpen}
        onCancel={() => {
          setDetailOpen(false);
        }}
        width={800}
        footer={null}
      >
        <DetailTable
          question_id={question_id}
          drillActions={newActionId}
          dimField={dimField}
          dimValue={lastClickedDimRef.current}
        />
      </Modal>
    </>
  );
}

export default PieData;
